/**
 * Keyboard Boot File
 *
 * Installs the global soft-keyboard avoidance behaviour once at startup: keeps the
 * focused input visible above the on-screen keyboard and publishes the
 * `--keyboard-inset-height` CSS variable that fixed/sticky bottom bars lift by.
 * See src/composables/useKeyboardInsets.ts for the mechanics (VisualViewport-based,
 * touch-gated, no native plugin).
 */
import { defineBoot } from '#q-app';
import { useKeyboardInsets } from 'src/composables/useKeyboardInsets';

export default defineBoot(() => {
  useKeyboardInsets().install();
});
